export default __webpack_public_path__ + "static/media/team_2025.f8bba906.jpg";